/**
 * Options to pick any of, each a pill (see /styleguide): blue once picked
 */
import * as preact from "preact";

import type { SelectOption } from "ui/Select";

interface Props {
  options: SelectOption[];
  selected: string[];
  /** The option tapped, picked or not as `picked` */
  onToggle: (value: string, picked: boolean) => void;
  "aria-label"?: string;
}

export default class Chips extends preact.Component<Props> {
  render() {
    return (
      <div class="chips" role="group" aria-label={this.props["aria-label"]}>
        {this.props.options.map((option) => {
          const picked = this.props.selected.includes(option.value);
          return (
            <button
              type="button"
              key={option.value}
              class={picked ? "chip selected" : "chip"}
              aria-pressed={picked}
              onClick={() => this.props.onToggle(option.value, !picked)}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    );
  }
}
